<template>
  <main>
    <div id="my-account-container" class="grid-x grid-container large-padding-top-xxl large-padding-bottom-xxl small-padding-bottom-l cell">
      <div v-if="route.meta.showLeftNav" class="cell small-12 large-3 show-for-large large-padding-right-s">
        <LeftNav />
      </div>
      <div class="cell small-12" :class="pageClass()">
        <NuxtPage />
      </div>
    </div>
  </main>
</template>

<script setup>
import { onMounted } from 'vue';
import LeftNav from '@/components/common/LeftNav';
import { loadTagLibrary } from '@vue-util/tagManager';
import { ExperimentationTags } from '@vue-util/experimentation';
import sessionTimeOutHandler from '@/utils/SessionTimeOutHandler';
import { useEnvPropsStore } from '@/stores/useEnvPropsStore';
import { headLinks } from '@/utils/headLinks';

const route = useRoute();

const envProps = useEnvPropsStore();

useHead(() => ({
  link: headLinks,
}));

const pageClass = () => {
  if (route.meta.showLeftNav) {
    return route.name === 'profile-management' ? 'large-7' : 'large-9';
  }
  return 'large-12';
};

onBeforeMount(() => {
  requestInterceptor();
  sessionTimeOutHandler();
});

onMounted(async () => {
  if (route.name !== 'profile-management') {
    window.medalliaSurveyData = 'in My Account';
  }
  const isAggregateSignIn = !!route.path?.includes('/account/signin/aggregator');
  if (!isAggregateSignIn) {
    loadTagLibrary(import.meta.env.VITE_ENTRY_POINT, envProps.tagManagerEnv, true);
  }
  //auto-tagging
  await ExperimentationTags.fireAdobeTags();
});
</script>
